import { render, staticRenderFns } from "./LeaderboardPlayerListComponent.vue?vue&type=template&id=26e821cc&scoped=true&"
import script from "./LeaderboardPlayerListComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardPlayerListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardPlayerListComponent.vue?vue&type=style&index=0&id=26e821cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e821cc",
  null
  
)

export default component.exports